import cls from 'clsx';
import { ALLOTMENT_STATUS } from '@link/share/constants';
import StockIcon from '../StockIcon';
import type { TimeSlotChipsProps } from './TimeSlotChips.types';
import styles from './timeSlotChips.module.css';

/** The start times as a grid of chips, each with its stock mark. */
const TimeSlotChips = ({ slots, value, onSelect }: TimeSlotChipsProps) => (
  <div className={styles.grid}>
    {slots.map(slot => {
      const soldOut = slot.stock === ALLOTMENT_STATUS.SOLD_OUT;
      const selected = slot.id === value;
      return (
        <button
          key={slot.id}
          type="button"
          className={cls(
            styles.chip,
            selected && styles.selected,
            slot.stock === ALLOTMENT_STATUS.LIMITED && styles.limited
          )}
          disabled={soldOut}
          aria-pressed={selected}
          onClick={() => onSelect(slot.id)}
        >
          <StockIcon status={slot.stock} className={styles.mark} />
          <span>{slot.label}</span>
        </button>
      );
    })}
  </div>
);

export default TimeSlotChips;
